export const policyInfoPageNumber = 1
export const requiredDocumentPageNumber = 2
export const lossDamageDetailsPageNumber = 3
// export const reviewPageNumber = 7
export const submittedClaimPageNumber = 4

export const basicCoverageDetailId = 334

export const lossDamageDetailsFormName = "Loss or Damage"
export const reviewFormName = "ReviewForm"

export const sep = "/"
